import Cookies from 'js-cookie'
import router from '../router'

const TokenKey = 'Admin-Token'
const Roles = 'User-Role'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function getRole () {
  return Cookies.get(Roles)
}

export function setRole (param) {
  return Cookies.set(Roles, param)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js